import React from "react";
import {
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaYoutube,
    FaLinkedinIn,
    FaVimeo,
    FaPinterest,
    FaTiktok,
} from "react-icons/fa";
import { IFooterProps } from "./util";
import { ESocialChannel, IOffice } from "../../lib/Contact/types";
import { ContactForm } from "../Forms/ContactForm";

export const FooterLayoutOfficesColumn: React.FC<IFooterProps> = ({
    className = "",
    logo,
    logoClassName = "",
    linkFunc,
    socialMediaLinks,
    linksGroups,
    offices,
    formProps,
    copyright,
    showAttribution
}) => {
    const LinkF = linkFunc || ((props) => <a {...props} />);
    const officesPairs = Array();
    let officesPair = Array();
    offices?.forEach((office, index) => {
        if (officesPair.length < 2) {
            officesPair.push(office)
        }
        if (officesPair.length == 2 || (offices.length == index + 1)) {
            officesPairs.push(officesPair)
            officesPair = Array()
        }
    })
    return (
        <footer className={`relative flex flex-col items-center w-full px-10 py-5 ${className}`}>
            <div className={`relative w-full max-w-screen-xl mx-auto flex flex-row flex-wrap justify-start border-b gap-y-2.5`}>
                <div className="w-full md:w-7/12 lg:w-8/12">
                    {logo && (
                        <LinkF
                            href="/"
                            className="w-auto"
                        >
                            <>
                                <span className="sr-only">Homepage</span>
                                <img
                                    className={`w-40 ${logoClassName}`}
                                    src={logo.url}
                                    width={logo.dimensions?.[0]}
                                    height={logo.dimensions?.[1]}
                                    alt={logo.caption}
                                />
                            </>
                        </LinkF>
                    )}
                </div>
                <div className="w-full md:w-5/12 lg:w-4/12 flex flex-row flex-wrap gap-3">
                    {socialMediaLinks && socialMediaLinks.map((item, i) => (
                        <a
                            key={i}
                            href={`${item.url}`}
                            title={item.text}
                            target={item.target}
                            className="text-4xl"
                        >
                            {(() => {
                                switch (item.channel) {
                                    case ESocialChannel.Facebook:
                                        return <FaFacebookF />;
                                    case ESocialChannel.Twitter:
                                        return <FaTwitter />;
                                    case ESocialChannel.Instagram:
                                        return <FaInstagram />;
                                    case ESocialChannel.YouTube:
                                        return <FaYoutube />;
                                    case ESocialChannel.LinkedIn:
                                        return <FaLinkedinIn />;
                                    case ESocialChannel.Vimeo:
                                        return <FaVimeo />;
                                    case ESocialChannel.Pinterest:
                                        return <FaPinterest />;
                                    case ESocialChannel.TikTok:
                                        return <FaTiktok />;
                                    default:
                                        return null;
                                }
                            })()}
                        </a>
                    ))}
                </div>
                <div className="w-full md:w-7/12 lg:w-8/12 flex flex-col md:pr-8 lg:pr-24">
                    {linksGroups && linksGroups.length > 0 && (
                        <div className="w-full flex flex-row flex-wrap gap-y-3 pb-6 pt-2.5 border-b">
                            {linksGroups.map((group, index) => (
                                <dl key={index} className="w-full md:w-1/2">
                                    <dt className="font-bold">{group.title}</dt>
                                    {group.links && group.links.length > 0 && group.links.map((link, key) => (
                                        <dd key={key}><a href={link.url} target={link.target}>{link.text}</a></dd>
                                    ))}
                                </dl>
                            ))}
                        </div>
                    )}
                    {officesPairs.length > 0 && officesPairs.map((pair, pairIndex) => (
                        <div key={pairIndex} className="footer-offices w-full flex flex-row flex-wrap pb-7 pt-6 border-b">
                            {pair && pair.map((office: IOffice, officeIndex: number) => (
                                <div key={officeIndex} className="footer-office w-full md:w-1/2 flex flex-col">
                                    <span className="block pb-2.5 font-bold">{office.fullName}</span>
                                    {office.address?.street1 && <span>{office.address.street1}</span>}
                                    {office.address?.city && <span>{office.address.city}{office.address.state ? `, ${office.address.state}` : ""}{office.address.postal ? ` ${office.address.postal}` : ""}</span>}
                                    {office.phone && <span>Phone:&nbsp;<a href={`tel:${office.phone}`}>{office.phone}</a></span>}
                                </div>
                            ))}
                        </div>
                    ))}
                </div>
                <div className="w-full md:w-5/12 lg:w-4/12">
                    <ContactForm {...formProps} />
                </div>
            </div>
            <div className="w-full max-w-screen-xl text-xs py-4">
                {copyright && (
                    <div dangerouslySetInnerHTML={{ __html: copyright }}></div>
                )}
                {showAttribution && (
                    <div className="attribution pt-4">
                        Real estate website design, development and optimization by{" "}
                        <a href="https://www.organicreturn.com/" className="font-bold">
                            Organic Return
                        </a>
                    </div>
                )}
            </div>
        </footer>
    )
}

export default FooterLayoutOfficesColumn